<template>
    <webinars :webinars="webinars"/>
</template>

<script>
    import { mapActions, mapGetters, mapState } from 'vuex';
    import Webinars from './Webinars.vue';

    export default {
        name: 'webinars-container',
        components: {
            Webinars,
        },
        computed: {
            ...mapGetters('training', ['webinars']),
        }
    }
</script>


// WEBPACK FOOTER //
// WebinarsContainer.vue?7af333b6